import Map from '@/model';
export default Map;
